import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownToggle from 'react-bootstrap/DropdownToggle';
import DropdownMenu from 'react-bootstrap/DropdownMenu';
import DropdownItem from 'react-bootstrap/DropdownItem';
import DropdownDivider from 'react-bootstrap/DropdownDivider';
import CustomToggle from '../CustomToggle';
import HotjarMasked from '../HotjarMasked';
import noop from '../../utils/noop';
import shouldHotjarMaskReportColumn from '../../utils/shouldHotjarMaskReportColumn';

import './styles.css';

const TableColumnFilter = ({
  id,
  children,
  options,
  filtering,
  onSelectHandler,
  keyName
}) => {
  return (
    <Dropdown
      id={`dropdown-custom-${id}`}
      onSelect={(onSelectHandler)}
      className="table-column-filter btn-group"
    >
      <DropdownToggle as={CustomToggle} >
        {children}
        <span className="caret" />
      </DropdownToggle>

      <DropdownMenu as="ul">
        <li><DropdownItem>Check All</DropdownItem></li>
        <li>
          <DropdownItem eventKey="UNCHECKALL" data-items={options}>
          Uncheck All
          </DropdownItem>  
        </li>
        <DropdownDivider as="li"/>
        {options.sort().map(option => (
          <li key={`dropdown-custom-${id}-${option}`}>
            <DropdownItem eventKey={option}>
              <i
                className={`card-docs-icon icon-budicon-${filtering.includes(
                  option
                )
                  ? '721'
                  : '415'}`}
                style={{ paddingRight: '15px' }}
              />
              {shouldHotjarMaskReportColumn(keyName) ? (
                <HotjarMasked isInline>{option}</HotjarMasked>
              ) : (
                option
              )}
            </DropdownItem>
          </li>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

TableColumnFilter.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object
  ]),
  id: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  filtering: PropTypes.array.isRequired,
  onSelectHandler: PropTypes.func.isRequired,
  keyName: PropTypes.string
};

TableColumnFilter.defaultProps = {
  onSelectHandler: noop
};

export default TableColumnFilter;
